import { createIcon } from "@chakra-ui/react";

export const Leaf = createIcon({
  displayName: "Leaf",
  viewBox: "0 0 72 72",
  path: [
    <mask
      id="92k7i6x90a"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="73"
      height="72"
    >
      <path fill="#D9D9D9" d="M.864 0h72v72h-72z" />
    </mask>,
    <g mask="url(#92k7i6x90a)">
      <path
        d="m22.294 21.017-6.65 6.515-4.033 8.525-3.659 8.6-1.507 9.385-1.199 10.095 10.089-.244 9.426-.71 8.972-2.638 8.365-4.076 7.337-5.682 5.629-7.379 5.65-7.398 3.188-8.92 1.89-9.362.413-10.094-10.033-.662-9.366 1.421-9.012 2.58-8.078 4.548-7.422 5.496z"
        fill="currentColor"
      />
    </g>,
  ],
  defaultProps: {
    color: "#C2BFE5",
  },
});

export default Leaf;
